const BackButton = {
  el: {
    root: document.querySelectorAll<HTMLAnchorElement>('.back-button'),
  },
  init () {
    if (this.el.root) {
      Array.prototype.forEach.call(this.el.root, (item: HTMLAnchorElement) => {
        if (item.classList.contains('back--history')) {
          item.addEventListener('click', (e: Event & {target: HTMLAnchorElement}) => {
            e.preventDefault()
            window.history.back()
          })
        }
      })
    }
  },
}

export default BackButton
